import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Card from "../../Card";
import CardWrapper from "../../CardWrapper";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import {
  getTotalSamples,
  getActiveDatabases,
} from "../../../../state/selectors/CancerSamples.selectors";
import { getAMPSOMARule } from "../../../../state/selectors/AMPComponent.selectors";

const AggregateCard = ({ card, totalSamples, totalDatabases, color }) => {
  const backgroundColor = getPathogenicityColorByAllNames(color);
  return (
    <CardWrapper {...card} color={backgroundColor}>
      <div className="tw-flex">
        <div className="tw-mr-2">
          Samples: <b>{totalSamples}</b>
        </div>
        <div>
          Sources: <b>{totalDatabases}</b>
        </div>
      </div>
      <div>
        <b style={{ color: backgroundColor }}>{color}</b>
      </div>
    </CardWrapper>
  );
};

AggregateCard.propTypes = {
  totalSamples: PropTypes.number,
  totalDatabases: PropTypes.number,
  color: PropTypes.string,
  card: PropTypes.instanceOf(Card).isRequired,
};

AggregateCard.defaultProps = {
  totalSamples: 0,
  totalDatabases: 0,
  color: "",
};

const mapStateToProps = (state) => ({
  totalSamples: getTotalSamples(state),
  totalDatabases: getActiveDatabases(state),
  color: getAMPSOMARule(state),
});

export default connect(mapStateToProps)(AggregateCard);
